import { twMerge } from "tailwind-merge";

export function OverHeading({
  children,
  elementType,
  className,
  id,
}: {
  children: React.ReactNode;
  elementType: "p" | "h1" | "h2" | "span" | "dt";
  className?: string;
  id?: string;
}) {
  const Element = elementType;

  return (
    <Element
      className={twMerge(
        "text-base font-semibold leading-7 text-primary",
        className
      )}
      id={id}
    >
      {children}
    </Element>
  );
}
